import { gql } from "@apollo/client";

export const CREATE_MY_VIEW_TRANSFORM_VT = gql`
  mutation CreateMyViewTransformVT($input: CreateMyViewTransformInput!) {
    createMyViewTransform(input: $input) {
      id
      status
      s3Url
      parquetData
      errorMessage
      isExisting
      runSettingsUsed
    }
  }
`;

export interface CreateMyViewTransformVTInput {
  transformId: string;
  transformationSettings: string;
  runSettings?: string | null;
  forceRecalc?: boolean;
}

export interface CreateMyViewTransformVTResult {
  createMyViewTransform: {
    id: string;
    status: "IN_PROGRESS" | "COMPLETED" | "FAILED";
    s3Url?: string | null;
    parquetData?: string | null;
    errorMessage?: string | null;
    isExisting?: boolean;
    runSettingsUsed?: string | null;
  };
}
